module.exports = __webpack_public_path__ + "img/pink_palms.fc48dd9a.jpg";